import React from 'react';
import { SIDE_MENU_EVENTS } from '@src/components/menu/sideMenu';
import SideDrawerElement from '@src/components/menu/sideDrawerElement';

export default function PackZepeto({ items, inProgress, callback }) {
  return (
    <>
      {items.map((element, index) => {
        return (
          <SideDrawerElement
            key={index}
            classes={''}
            thumbnail={element?.image}
            callback={() => {
              callback({
                name: element.name,
                url: element.url,
                type: SIDE_MENU_EVENTS.LIBRARY_3D,
                index,
              });
            }}
            name={element.name}
            inProgress={inProgress}
          />
        );
      })}
    </>
  );
}
